module.exports = __webpack_public_path__ + "assets/img/zizhi.7286cb0b.png";